export default function(){var callback=arguments[0];return arguments[0]=this,callback.apply(null,arguments),this}